import {Component, ComponentOptions} from "@mecatran-components/component";
import {ScheduleTable} from "./scheduletable.component.mjs";



export class Schedules extends Component{
    constructor(schedulesOptions){
        var schedulesOptions = schedulesOptions || {};
        var options = new ComponentOptions(); 
        options.setDomOptions(schedulesOptions.domOptions); 
        super(options);
        this.initSchedules(schedulesOptions);
    }
    // ==========
    // private 
    // ----------
    setItineraryGroup(itineraryGroup){ this.itineraryGroup = itineraryGroup; }

    getItineraryGroup(){ return this.itineraryGroup; }

    getDirection(){ return this.direction }

    getDisplayAllStops(){ return this.displayAllStops; }

    createItineraryGroupSamePatternHK(itineraryGroup){
        var ItineraryGroup = itineraryGroup.getConstructor();
        return (patternHashKey)=> itineraryGroup.getItineraryGroupBy(ItineraryGroup.filterByPatternHashKey(patternHashKey))
    }

    createScheduleTableComponent(itineraryGroup){
        var domOptions = { id : 'schedule-table', classList : ['schedule-table']}
        var displayAllStops = this.getDisplayAllStops();
        var scheduleTableOptions = { itineraryGroup, displayAllStops : true, domOptions }
        var scheduleTable = new ScheduleTable(scheduleTableOptions)  
        return scheduleTable;      
    }

    addScheduleTableComponents(scheduleTables){
        this.addSubComponents(scheduleTables,'scheduleTables')
    }

    


    initSchedules(schedulesOptions){
        this.setDisplayAllStops(schedulesOptions.displayAllStops);
        this.setItineraryGroup(schedulesOptions.itineraryGroup);
        this.setDirection(schedulesOptions.direction || 'outb')

        this.build();
    }

    // ==========
    // overloaded
    // ----------
    build(){
        // do not forget to clear the storageManager 
        var itineraryGroup = this.getItineraryGroup();
        var direction = this.getDirection();

        var ItineraryGroup = itineraryGroup.getConstructor();
        itineraryGroup = itineraryGroup.getItineraryGroupBy( ItineraryGroup.filterByDirection(direction));

        console.log('number of patternHashKeys', itineraryGroup.getPatternHashKeys().length)
        var scheduleTables = itineraryGroup.getPatternHashKeys()
                        .map(this.createItineraryGroupSamePatternHK(itineraryGroup))
                        .map(this.createScheduleTableComponent.bind(this))

        this.addScheduleTableComponents(scheduleTables);

        super.build();

    }

    // ==========
    // overload 
    // ----------
    createContainerNode(){
        var div = document.createElement('div');
        div.classList.add('schedules')
        return div;
    }

    createContentNode(){ return; }

    // ==========
    // public 
    // ----------
    setDisplayAllStops(b){ this.displayAllStops = b }



    setDirection(direction){ this.direction = direction }


}


class SchedulesOptions{}
/**
 * schedulesOptions Interface
 * --------------------------
 * itineraryGroup - mandatory 
 * displayAllStops boolean 
 * domOptions
 * direction outb || inb
 */

